function downloadWorkflowAI(workflow, fallbackId) {
  const prefix = 'data:text/json;charset=utf-8,';
  const dataStr = prefix + encodeURIComponent(JSON.stringify(workflow));
  const link = document.createElement('a');
  const fileName = `${workflow.name || workflow.id || fallbackId}-ai.json`;
  link.setAttribute('href', dataStr);
  link.setAttribute('download', fileName);
  link.click();
  link.remove();
}

const exportWorkflowAI = async (store, workflow_id) => {
  const { dispatch } = store;
  try {
    dispatch(
      'notifications/pushNotification',
      'Exporting workflow for AI. Please wait',
      {
        root: true,
      }
    );
    const url = `/proxy/export-workflow?workflow_id=${workflow_id}&format=ai`;
    const response = await window.axios.get(url);

    if (response && response.data.success) {
      downloadWorkflowAI(response.data.workflow || {}, workflow_id);
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  }
};

export default exportWorkflowAI;
